// extracted by mini-css-extract-plugin
export var boxed = "styles-module--boxed--28a09";
export var check = "styles-module--check--3c2d4";
export var checkbox = "styles-module--checkbox--69919";
export var checkmark = "styles-module--checkmark--344d3";